<main>
    <div *ngIf="!adminActive" class="main-navbar-colors">
        <div *ngIf="router.url === '/' && !isSmallScreenMain" id="logo-top" class="text-center">
            <img class="logo mt-3" src="/assets/images/home/logo.png" alt="logo image">
        </div>
        <nav class="navbar main-navbar">
            <div class="nav-container">
                <div class="mobile-header-row" *ngIf="isSmallScreenMain">
                    <button mat-button class="menu-toggle" (click)="toggleMainMenu()">
                        <mat-icon class="main-menu-light">
                            {{ mainMenuOpen ? 'close' : 'menu' }}
                        </mat-icon>
                    </button>
                    <a class="mobile-brand" routerLink="/">
                        <img src="/assets/images/home/logo.png" alt="PropertyMatrix" class="mobile-brand-logo">
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/" routerLinkActive="active"
                       [routerLinkActiveOptions]="{ exact: true }">
                        HOME
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/about-us" routerLinkActive="active">
                        ABOUT US
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/property-for-sale" routerLinkActive="active">
                        PROPERTY FOR SALE
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/sell-your-property" routerLinkActive="active">
                        SELL YOUR PROPERTY
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/share-in-our-database" routerLinkActive="active">
                        PLACE YOUR ORDER
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/additional-services" routerLinkActive="active"
                       [routerLinkActiveOptions]="{ exact: false }" [matMenuTriggerFor]="additionalServicesMenu">
                        ADDITIONAL SERVICES
                    </a>
                    <mat-menu #additionalServicesMenu="matMenu" class="additional-services-menu">
                        <button mat-menu-item routerLink="/additional-services/property-investigation">
                            <span>Property Investigations</span>
                        </button>
                        <button mat-menu-item routerLink="/additional-services/feasibility-studies">
                            <span>Feasibility Studies</span>
                        </button>
                        <button mat-menu-item routerLink="/additional-services/town-planning-application">
                            <span>Planning Applications</span>
                        </button>
                        <button mat-menu-item routerLink="/additional-services/property-valuation">
                            <span>Property Valuation</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen">
                    <a class="nav-link heading-3-light" routerLink="/get-in-touch" routerLinkActive="active">
                        CONTACT US
                    </a>
                </div>

                <!-- Desktop only: hamburger mat-menu -->
                <div class="m-2 nav-item" *ngIf="!isSmallScreenMain">
                    <button mat-button [matMenuTriggerFor]="mainMenu">
                        <mat-icon class="main-menu-light">menu</mat-icon>
                    </button>
                    <mat-menu #mainMenu="matMenu" class="main-menu">
                        <button mat-menu-item routerLink="/listing-advisors">
                            <span>Agent Support</span>
                        </button>
                        <button mat-menu-item *ngIf="isLoggedIn" routerLinkActive="active" routerLink="/admin/home"
                                (click)="enableAdminNav()">
                            <span>Admin Portal</span>
                        </button>
                        <button mat-menu-item *ngIf="!isLoggedIn" (click)="goToRegister()">
                            <span>Register</span>
                        </button>
                        <button mat-menu-item *ngIf="!isLoggedIn" (click)="onClickLogin()">
                            <span>Log In</span>
                        </button>
                        <button mat-menu-item *ngIf="isLoggedIn" (click)="onClickLogout()">
                            <span>Log Out</span>
                        </button>
                    </mat-menu>
                </div>

                <!-- Mobile: these items appear in the same burger menu as other nav items -->
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen" *ngIf="isSmallScreenMain">
                    <a class="nav-link heading-3-light" routerLink="/listing-advisors" routerLinkActive="active">
                        AGENT SUPPORT
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen" *ngIf="isSmallScreenMain && isLoggedIn">
                    <a class="nav-link heading-3-light" routerLink="/admin/home" routerLinkActive="active"
                       (click)="enableAdminNav()">
                        ADMIN PORTAL
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen" *ngIf="isSmallScreenMain && !isLoggedIn">
                    <a class="nav-link heading-3-light" (click)="goToRegister()">
                        REGISTER
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen" *ngIf="isSmallScreenMain && !isLoggedIn">
                    <a class="nav-link heading-3-light" (click)="onClickLogin()">
                        LOG IN
                    </a>
                </div>
                <div class="m-2 nav-item" [class.hide]="isSmallScreenMain && !mainMenuOpen" *ngIf="isSmallScreenMain && isLoggedIn">
                    <a class="nav-link heading-3-light" (click)="onClickLogout()">
                        LOG OUT
                    </a>
                </div>
            </div>
        </nav>
    </div>
    <div *ngIf="adminActive" class="row admin-navbar-colors">
        <div class="company-title col">
            Property Matrix
        </div>
        <div class="col">
            <nav class="navbar admin-navbar">
                <div class="admin-nav-container">
                    <h2 class="m-2 nav-item" *ngIf="isSmallScreenAdmin">
                        Property Matrix
                    </h2>
                    <button mat-button class="menu-toggle" (click)="toggleAdminMenu()" *ngIf="isSmallScreenAdmin">
                        <mat-icon>
                            {{ adminMenuOpen ? 'close' : 'menu_open' }}
                        </mat-icon>
                    </button>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen">
                        <a class="nav-link heading-3 admin-nav" routerLink="/admin/home" routerLinkActive="active">
                            HOME
                        </a>
                    </div>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen">
                        <a class="nav-link heading-3 admin-nav" routerLink="/admin/listings" routerLinkActive="active">
                            LISTINGS
                        </a>
                    </div>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen" *ngIf="showUserTab">
                        <a class="nav-link heading-3 admin-nav" routerLink="/admin/users" routerLinkActive="active"
                           [attr.tabindex]="showUserTab ? null : -1">
                            USERS
                        </a>
                    </div>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen">
                        <a class="nav-link heading-3 admin-nav" routerLink="/admin/profile" routerLinkActive="active">
                            PROFILE
                        </a>
                    </div>

                    <!-- Desktop only: hamburger mat-menu -->
                    <div class="m-2 nav-item" *ngIf="isLoggedIn && !isSmallScreenAdmin">
                        <button mat-button [matMenuTriggerFor]="adminMenu">
                            <mat-icon>menu</mat-icon>
                        </button>
                        <mat-menu #adminMenu="matMenu" class="admin-menu">
                            <button mat-menu-item routerLink="/" (click)="disableAdminNav()">
                                <span>Main Site</span>
                            </button>
                            <button mat-menu-item *ngIf="!isLoggedIn" (click)="onClickLogin()">
                                <span>Log In</span>
                            </button>
                            <button mat-menu-item *ngIf="isLoggedIn" (click)="onClickLogout()">
                                <span>Log Out</span>
                            </button>
                        </mat-menu>
                    </div>

                    <!-- Mobile: these items appear in the same burger menu as other nav items -->
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen" *ngIf="isSmallScreenAdmin">
                        <a class="nav-link heading-3 admin-nav" routerLink="/" (click)="disableAdminNav()">
                            MAIN SITE
                        </a>
                    </div>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen" *ngIf="isSmallScreenAdmin && !isLoggedIn">
                        <a class="nav-link heading-3 admin-nav" (click)="onClickLogin()">
                            LOG IN
                        </a>
                    </div>
                    <div class="m-2 nav-item" [class.hide]="isSmallScreenAdmin && !adminMenuOpen" *ngIf="isSmallScreenAdmin && isLoggedIn">
                        <a class="nav-link heading-3 admin-nav" (click)="onClickLogout()">
                            LOG OUT
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</main>
<router-outlet></router-outlet>
<app-footer></app-footer>
